<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >
    <FormulateInput
        type="checkbox"
        :name="context.name"
        :options="context.options"
        v-model="context.model"
        @blur="context.blurHandler" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  watch: {
    model (newValue,oldValue) {
      if ( newValue !== oldValue ) {
        // changed
        if (
            !oldValue.includes('none') &&
            newValue.includes('none')
          ) {
          // none just selected, toggle everything off
          this.context.model = ['none'];

        } else if (
            newValue.includes('none') &&
            newValue.length > 1
          ) {
          // something else just selected, toggle 'none' off
          this.context.model = this.context.model.filter(item => item !== 'none');
        }
      }
    }
  },
  beforeMount() {
    
  },
  computed: {
      model () {
        return this.context.model
      },
      ...mapGetters({ answers: 'flattenedAnswers'})
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
  
</style>